import { render, staticRenderFns } from "./BulkFieldMapping.vue?vue&type=template&id=2ae66bd1&scoped=true&"
import script from "./BulkFieldMapping.vue?vue&type=script&lang=ts&"
export * from "./BulkFieldMapping.vue?vue&type=script&lang=ts&"
import style0 from "./BulkFieldMapping.vue?vue&type=style&index=0&id=2ae66bd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae66bd1",
  null
  
)

export default component.exports